module.exports = __webpack_public_path__ + "img/logo.da897af9.png";